import { VideoPlayer } from '../blocks/YouFitnessTemplate/VideoBlock'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import * as S from './ModalSlider.styled'
import { useState, useEffect } from 'react'

export interface ModalSliderProps {
  isOpen: boolean
  toggleModal: () => void
  initIndex: number
  media: {
    image?: string
    video?: string
  }[]
}

const ModalSlider: React.FC<ModalSliderProps> = ({
  isOpen,
  toggleModal,
  initIndex,
  media
}) => {
  const [selectedSlide, setSelectedSlide] = useState<number>(-1)

  useEffect(() => {
    setSelectedSlide(initIndex)
  }, [initIndex])

  // Video iframes (Vimeo/YouTube) steal keyboard focus, which prevents the
  // document-level Escape listener from closing the modal. Return focus to the
  // page whenever the iframe grabs it so Escape keeps working.
  useEffect(() => {
    if (!isOpen) return

    const releaseIframeFocus = () => {
      const active = document.activeElement
      if (active && active.tagName === 'IFRAME') {
        ;(active as HTMLElement).blur()
      }
    }

    const interval = window.setInterval(releaseIframeFocus, 150)
    window.addEventListener('blur', releaseIframeFocus)

    return () => {
      window.clearInterval(interval)
      window.removeEventListener('blur', releaseIframeFocus)
    }
  }, [isOpen])

  return (
    <S.SliderModal
      isOpen={isOpen}
      onEscapeKeydown={toggleModal}
      onBackgroundClick={toggleModal}
    >
      <S.SliderWrap>
        <S.Close onClick={toggleModal}>&times;</S.Close>
        <Carousel
          showStatus={false}
          infiniteLoop={false}
          selectedItem={selectedSlide}
          showThumbs={false}
          onChange={idx => setSelectedSlide(idx)}
        >
          {media.map((it: any, key: number) =>
            it.video ? (
              <S.CarouselItem key={key}>
                <VideoPlayer
                  videoURL={it.video}
                  thumbnailURL={it.image}
                  autoPlay={selectedSlide === key}
                />
              </S.CarouselItem>
            ) : (
              <S.CarouselItem key={key}>
                <img src={it.image} alt='' />
              </S.CarouselItem>
            )
          )}
        </Carousel>
      </S.SliderWrap>
    </S.SliderModal>
  )
}

export default ModalSlider
